import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
    cloneDeep as _cloneDeep,
    isEqual as _isEqual,
} from 'lodash';

import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';

import Validator, { useValidate, checkValidity } from '../../../components/validator';

import AssetsService from '../../../data/assets-service';
import DataContext from '../../../data/data-context';

const useStyles = makeStyles(theme => ({
    buttonRight: {
        float: 'right',
        marginLeft: theme.spacing(2),
    },
    select: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
        width: '100%',
    },
}));

const DEFAULT_ASSET = { name: '', ip: '' };

const CreateAsset = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const routeParams = useParams();
    const [isUpdate, setIsUpdate] = useState(false);
    const [ogAsset, setOGAsset] = useState(_cloneDeep(DEFAULT_ASSET));
    const [asset, setAsset] = useState(_cloneDeep(DEFAULT_ASSET));
    const [change, setChange] = useState(false);
    const [kick, setKick] = useState(false);
    const assetForm = useValidate({});
    const { refresh, createAsset, updateAsset } = useContext(DataContext);

    useEffect(() => {
        if (routeParams.ip) {
            setIsUpdate(true);
            AssetsService.getAsset(routeParams.ip).then((res) => {
                setTimeout(() => {
                    setOGAsset(res);
                    setAsset(res);
                });
            });
        }

        setKick(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setChange(!_isEqual(ogAsset, asset));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [asset]);

    const handleUpdateAssetData = (e, validID, valid) => {
        assetForm.set({ ...assetForm.get(), [validID]: valid });

        setAsset({
            ...asset,
            [e.target.getAttribute('dataname')]: e.target.value,
        });
    };

    const handleCreateAsset = () => {
        if (isUpdate) {
            updateAsset({ orig: routeParams.ip, ip: routeParams.ip, ...asset }).then(() => {
                // refresh assets context for ip controls
                if (refresh && Object.prototype.hasOwnProperty.call(refresh, 'call')) {
                    refresh();
                }
                navigate('/system/assets');
                toast.success('Asset updated successfully');
            }, err => {
                if (err.Message && err.Message.includes('duplicate')) {
                    toast.error('Duplicate asset IP');
                }
            });
        } else {
            createAsset(asset).then(() => {
                // refresh assets context for ip controls
                if (refresh && Object.prototype.hasOwnProperty.call(refresh, 'call')) {
                    refresh();
                }
                navigate('/system/assets');
                toast.success('Asset created successfully');
            }, err => {
                if (err.Message && err.Message.includes('duplicate')) {
                    toast.error('Duplicate asset IP');
                }
            });
        }
    };

    const handleCancel = () => {
        navigate('/system/assets');
    };

    return (
        <Grid container spacing={2} direction="row">
            <Grid item xs={6}>
                <Paper elevation={3}>
                    <Box p={5}>
                        <Validator
                            valueType="assetName"
                            errorText="Name is invalid"
                            label="Name"
                            length={42}
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            kick={kick}
                            value={asset.name}
                            inputProps={{ dataname: 'name' }}
                            onChange={handleUpdateAssetData}
                        />
                        <Validator
                            valueType="ip"
                            errorText="IP address is invalid"
                            label="IP Address"
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            kick={kick}
                            value={asset.ip}
                            inputProps={{ dataname: 'ip' }}
                            onChange={handleUpdateAssetData}
                        />
                        <Box mt={3} pb={3}>
                            <Button
                                variant="contained"
                                className={classes.buttonRight}
                                aria-label={isUpdate ? 'Update' : 'Create'}
                                onClick={handleCreateAsset}
                                disabled={(() => {
                                    // Validation library needs an overhaul...
                                    if (!change) {
                                        return true;
                                    }
                                    if (change && asset.ip && asset.name && checkValidity(assetForm.get())) {
                                        return false;
                                    }

                                    return true;
                                })()}
                            >
                                {isUpdate ? 'Update' : 'Create'}
                            </Button>
                            <Button variant="contained" className={classes.buttonRight} aria-label="Cancel" onClick={handleCancel}>Cancel</Button>
                        </Box>
                    </Box>
                </Paper>
            </Grid>
        </Grid>
    );
};

export default CreateAsset;
